<template>
  <form action="#" @submit.prevent="submit">
    <fieldset>
      <label for="userPassword">
        {{ $t('userSignInForm.passwordLabel') }}
      </label>
      <Input
        v-model="form.password"
        :disabled="disabled"
        block
        type="password"
        name="userPassword"
        id="userPassword"
        placeholder="Entrez votre mot de passe"
        data-test="password-input"
        required
        :invalid="invalid"
      />
      <transition name="fade">
        <Alert v-if="invalid">Mot de passe invalide</Alert>
        <Alert v-if="disabled">
          {{ $t('userSignInForm.deactivatedAccount') }}
        </Alert>
      </transition>
    </fieldset>
    <Button
      block
      type="submit"
      size="lg"
      :loading="loading"
      data-test="submit-button"
      :disabled="disabled"
      @click.native="submit"
    >
      {{ $t('userSignInForm.submitButtonText') }}
    </Button>
    <a href="#" @click="handleForgotPassword" class="forgottenPwd">
      {{ $t('userSignInForm.forgotPassword') }}
    </a>
  </form>
</template>
<script>
import Input from '@/components/Input.vue';
import Alert from '@/components/Alert.vue';
import Button from '@/components/Button.vue';

export default {
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
  },
  components: {
    Input,
    Alert,
    Button,
  },
  data() {
    return {
      showForgotPassword: false,
      form: {
        password: '',
      },
    };
  },
  methods: {
    handleForgotPassword() {
      this.$emit('forgotPassword');
    },
    submit() {
      this.$emit('onLogin', { password: this.form.password });
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
